import React, { useEffect, useMemo, useState } from 'react'

import { Button, Select } from 'antd'

import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'

import moment from 'moment'
import R from 'ramda'

import { Label } from 'core/screen-util'
import { SppAcaSeasonHeaders } from './ACAHeaders'
import { deleteseason, getseason, postseason } from './acaapi'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { hasAccesPermits, monthsMap } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'

const ACASeason = ({ permitActions }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const monthSelection = useMemo(_ => {
    const mn = R.range(1, 13).map(m => (
      <Select.Option key={m} value={m}>
        {`${m} - ${monthsMap[m]}`}
      </Select.Option>
    ))
    return mn
  }, [])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '100px 100px 180px 130px 150px 130px 150px 130px 150px 130px 130px 150px 150px',
          gap: 5,
        }}
      >
        <Label>Effective Year :</Label>
        <Select
          value={insertData.effectiveYear}
          style={{ width: 120 }}
          onChange={val => {
            setInsertData({ ...insertData, effectiveYear: val })
          }}
        >
          {R.range(-15, 10).map(idx => {
            const y = moment().year() - idx
            return (
              <Select.Option key={y} value={y}>
                {y}
              </Select.Option>
            )
          })}
        </Select>
        {/* <InputNumber
          value={insertData.effectiveYear}
          onChange={val => setInsertData({ ...insertData, effectiveYear: val })}
        /> */}

        <Label>Summer Start Month :</Label>
        <Select
          // style={{ width: '150px' }}
          value={insertData.summerStartMonth}
          onChange={value =>
            setInsertData({ ...insertData, summerStartMonth: value })
          }
        >
          {monthSelection}
        </Select>

        <Label>Summer End Month :</Label>
        <Select
          // style={{ width: '150px' }}
          value={insertData.summerEndMonth}
          onChange={value =>
            setInsertData({ ...insertData, summerEndMonth: value })
          }
        >
          {monthSelection}
        </Select>

        <Label>Winter Start Month :</Label>
        <Select
          // style={{ width: '150px' }}
          value={insertData.winterStartMonth}
          onChange={value =>
            setInsertData({ ...insertData, winterStartMonth: value })
          }
        >
          {monthSelection}
        </Select>

        <Label>Winter End Month :</Label>
        <Select
          // style={{ width: '150px' }}
          value={insertData.winterEndMonth}
          onChange={value =>
            setInsertData({ ...insertData, winterEndMonth: value })
          }
        >
          {monthSelection}
        </Select>

        <div style={{ gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const [withoutModify, setWithoutModify] = useState(true)
  useEffect(() => {
    const isAdmin = hasAccesPermits({
      actionPermits: permitActions,
      eventActions: [ScreenPermissions.AEP_ACA_SPP_DATA_WRITE],
      matchAny: true,
    })
    setWithoutModify(!isAdmin)
  }, [permitActions])

  return (
    <CommonScreen
      title="SPP ACAP Seasons"
      header={SppAcaSeasonHeaders}
      initialSortOptions={SppAcaSeasonHeaders}
      saveTask={postseason}
      retrieveTask={getseason}
      deleteTask={deleteseason}
      altBy={d => d.effectiveYear}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      defaultInsertData={{ effectiveYear: moment().year() }}
      isAdminScreen={false}
      withoutModify={withoutModify}
      allowInsert={!withoutModify}
      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(ACASeason)
